import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'servicedesk-views-onboarding.views-nav-item-onboarding.heading',
		defaultMessage: 'Board + Calendar = Views',
		description: 'The views onboarding spotlight heading',
	},
	description: {
		id: 'servicedesk-views-onboarding.views-nav-item-onboarding.description',
		defaultMessage: 'Switch between views to see issues in the way that works best for you.',
		description: 'The views onboarding spotlight content description',
	},
	readMore: {
		id: 'servicedesk-views-onboarding.views-nav-item-onboarding.read-more',
		defaultMessage: 'Read more',
		description: 'Learn more button on the views onboarding spotlight',
	},
	ok: {
		id: 'servicedesk-views-onboarding.views-nav-item-onboarding.ok',
		defaultMessage: 'OK',
		description: 'OK button on the views onboarding spotlight',
	},
	pulseLabel: {
		id: 'servicedesk-views-onboarding.views-nav-item-onboarding.pulse-label',
		defaultMessage: 'Learn more about views',
		description: 'Accessible label for the views onboarding pulse',
	},
});
